/**
 * One-way journeys (Madina → Koforidua): the shift ends on arriving at the far end, with a bonus. The server pays
 * the bonus itself, and only for a shift that really covered the road. Keep `length` equal to the route in the game
 * (a test checks it).
 */
export interface Journey {
  /** Road length, metres. */
  length: number;
  bonusPesewas: number;
  bonusScore: number;
}

export const JOURNEYS: Readonly<Record<string, Journey>> = {
  'madina-koforidua': { length: 12_000, bonusPesewas: 10_000, bonusScore: 5000 },
};

/** The most score an arrival can add, for the plausibility check. */
export const MAX_JOURNEY_SCORE_BONUS = Math.max(...Object.values(JOURNEYS).map((j) => j.bonusScore));

/** How much of the road must have been driven before an arrival counts (stops and the final braking leave a little short). */
const ARRIVAL_MIN_SHARE = 0.95;

/** The journey bonus for a shift on this route that claims to have arrived, or null. */
export function journeyBonus(routeId: string | null, metres: number): Journey | null {
  const journey = routeId ? JOURNEYS[routeId] : undefined;
  return journey && metres >= journey.length * ARRIVAL_MIN_SHARE ? journey : null;
}
